// extracted by mini-css-extract-plugin
export default {"Box":"row-reorder-sash-module__Box__EWV0rmN","Octicon":"row-reorder-sash-module__Octicon__lX8SYbZ"};